
const insuredCardStatusEnum = {
  EXPIRED: 'EXPIRED',
  NOT_STARTED: 'NOT_STARTED',
  RELEVANT: 'RELEVANT',
  VMS: 'VMS'
};
export default insuredCardStatusEnum;
